import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import ReactTable from "react-table"
import _ from 'lodash'
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import numeral from 'numeral'
import settings from 'settings'

//? This table behaves differently depending on settings.arc as well as settings.useFloorplanManualBasePricing

class MarketingFloorplans extends Component {
	constructor(props) {
		super(props)

		this.state = {
			filtered: [],
			columns: [
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Sq. Ft",
					accessor: "sqft",
				},
				{
					Header: "Stories",
					accessor: "stories",
				},
				{
					Header: "Beds",
					accessor: "beds",
				},
				{
					Header: "Full Baths",
					accessor: "full_baths",
				},
				{
					Header: "Half Baths",
					accessor: "half_baths",
				},
				{
					Header: "Garage",
					accessor: "garage",
				},
				{
					Header: "Lot Types",
					accessor: "lot_types",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_types"),
				},
				{
					Header: "Base Pricing",
					accessor: "base_pricing",
					filterMethod: (f, r) => helpers.tableText(f, r, "base_pricing"),
				},
			],
		}
	}

	generateLotTypePricing = (lot_types) => {
		let str = ""
		let useManual = settings.useFloorplanManualBasePricing
		if (Array.isArray(lot_types)) {
			_.forEach(lot_types, (row) => {
				// weed out properties not active
				if (!_.includes(this.props.activeProperties, row.property)) return
				let type = _.find(this.props.payload.public.lot_types, { id: row.lot_type })
				let property = _.find(this.props.payload.public.properties, { id: row.property })
				if (!type || !property) return
				if (useManual && row.manual_base_price) {
					str += `${property.name} - ${type.name}: ${numeral(row.manual_base_price).format("$0,0")}, `
				} else if (!useManual && row.base_price) {
					str += `${property.name} - ${type.name}: ${numeral(row.base_price).format("$0,0")}, `
				}
			})
		}
		str = _.trim(str, ", ")
		return str
	}

	generateLotTypes = (lot_types) => {
		let str = ""
		if (Array.isArray(lot_types)) {
			_.forEach(lot_types, (row) => {
				// weed out properties not active
				if (!_.includes(this.props.activeProperties, row.property)) return
				let type = _.find(this.props.payload.public.lot_types, { id: row.lot_type })
				let property = _.find(this.props.payload.public.properties, { id: row.property })
				if (!type || !property) return
				str += `${property.name} - ${type.name}, `
			})
		}
		str = _.trim(str, ", ")
		return str
	}

	buildTable = (type) => {
		let data = []
		//console.log(builders)
		_.forEach(this.props.payload.public.floorplans, (v) => {
			if (settings.arc) {
				if (!v.arc_approved) false // no arc approved in any community
				//? look at all the master plans that are approved in one of the active properties
				let approved = false
				_.forEach(v.arc_approved, (r, k) => {
					if (_.includes(this.props.activeProperties, r.property) && r.approved) {
						approved = true
						return false
					}
				})
				if (approved) {
					let r = {}
					r.id = v.id
					let builder = _.find(this.props.payload.public.builders, { id: v.builder })
					if (builder) {
						r.builder = builder.name
					}
					r.name = v.name
					r.sqft = v.sqft
					r.stories = v.stories
					r.beds = v.beds
					r.full_baths = v.full_baths
					r.half_baths = v.half_baths
					r.garage = v.garage
					r.base_pricing = this.generateLotTypePricing(v.lot_types)
					r.lot_types = this.generateLotTypes(v.lot_types)
					data.push(r)
				}
			} else {
				let int = _.intersection(v.properties, this.props.activeProperties)
				if (int.length == 0 || !v.status) {
					return
				}
				let r = {}
				r.id = v.id
				let builder = _.find(this.props.payload.public.builders, { id: v.builder })
				if (builder) {
					r.builder = builder.name
				}
				r.name = v.name
				r.sqft = v.sqft
				r.stories = v.stories
				r.beds = v.beds
				r.full_baths = v.full_baths
				r.half_baths = v.half_baths
				r.garage = v.garage
				r.base_pricing = this.generateLotTypePricing(v.lot_types)
				r.lot_types = this.generateLotTypes(v.lot_types)
				data.push(r)
			}
		})
		return data
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="communities">
					<Title title="Current Floorplans" showDate={false} />
					<div className="content">
						<p className="text-sm">
							The base pricing used is set to{" "}
							{settings.useFloorplanManualBasePricing ? "manual entry." : "feed-based pricing."}
						</p>
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							name="marketing__floorplans"
							title="floorplans"
							pageSize={20}
						/>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(MarketingFloorplans)
